module.exports = __webpack_public_path__ + "img/PPMP35.e2a63411.png";